import get from 'lodash/get'
import axios from 'axios'

const dwhEportUrl = get(window.__PRELOADED_STATE__, 'urls.dwh_export', '/')
const spaId = get(window.__PRELOADED_STATE__, 'currentAccount.id', 0)

export type DwhExportCreationTime = Date
export type DwhExportSpaId = number
export type DwhExportMeta = {
    building_id?: string, // supply.view_building
    battle_type?: string, // members.select_battle_type
    season?: string, // members.select_season
    search?: string, // search
    teamNumber?: number, // clan_battles.view_clan_history
    clan_id?: string, // search.open_clan || clanrec.send_request
    mode?: string, // clanrec.select_mode
    page_index?: string, // clanrec.change_page
}

class DwhExport {

    private url: string
    private spaId: number

    constructor(url: string, spaId: number) {
        this.url = url
        this.spaId = spaId
    }

    send = (event: string, meta: DwhExportMeta = {}) => {
        if (this.spaId) {
            const data = {
                event: event,
                meta: meta
            }
            axios.post(this.url, data).then(r => {

            }).catch(err => {
                console.error(err)
            })
        }
    }
}

export default new DwhExport(dwhEportUrl, spaId)